import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './form.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faCircleXmark
} from '@fortawesome/free-solid-svg-icons';

export default function Reg_Close() {
  useEffect(() => { AOS.init({ duration: 600, once: true }); }, []);

  return (
    <div className="jm-result-page">
      <div className="jm-result-card" data-aos="zoom-in">
        <div className="jm-result-icon-wrap">
          <div className="jm-result-icon info">
            <FontAwesomeIcon icon={faCircleXmark} />
          </div>
        </div>

        <div className="jm-result-body">
          <h2>Sorry, Registrations Closed!</h2>
          <div>
            Online registrations have been closed.
          </div>
          <div>
            Kindly visit the venue, Technology Club, at 6:00 p.m. to get offline passes for the event.
          </div>

          <div className="jm-result-actions">
            <Link to="/" className="jm-rbtn primary">
              <FontAwesomeIcon icon={faHouse} />
              Go to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}